import { useQuery } from '@tanstack/react-query';
import { Users, MapPin, Contact, Music, Mic2, UserPlus } from 'lucide-react';
import { adminAPI } from '../api/endpoints';

function StatCard({ label, value, icon: Icon }: { label: string; value: number; icon: React.ElementType }) {
  return (
    <div className="card p-6 flex items-center gap-4">
      <div className="w-12 h-12 rounded-xl bg-primary-900/50 flex items-center justify-center">
        <Icon className="w-6 h-6 text-primary-400" />
      </div>
      <div>
        <p className="text-2xl font-bold text-dark-text-primary">{value.toLocaleString()}</p>
        <p className="text-sm text-dark-text-secondary">{label}</p>
      </div>
    </div>
  );
}

export function AdminStatsPage() {
  const { data: stats } = useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: () => adminAPI.getStats().then((r) => r.data),
  });

  return (
    <div className="h-full flex flex-col animate-fadeIn">
    <div className="max-w-(--breakpoint-xl) mx-auto w-full p-6 flex-1 flex flex-col min-h-0 space-y-8">
      <h1 className="text-2xl font-bold text-dark-text-primary tracking-tight">Statistics</h1>

      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          <StatCard label="Users" value={stats.total_users} icon={Users} />
          <StatCard label="Venues" value={stats.total_venues} icon={MapPin} />
          <StatCard label="Contacts" value={stats.total_contacts} icon={Contact} />
          <StatCard label="Bands" value={stats.total_bands} icon={Music} />
          <StatCard label="Concerts" value={stats.total_concerts} icon={Mic2} />
          <StatCard label="New (7d)" value={stats.recent_signups} icon={UserPlus} />
        </div>
      )}
    </div>
    </div>
  );
}
